<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">
          Сведения о представителе физического лица
        </div>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
          label="Фамилия"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
          label="Имя"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
          label="Отчество (при наличии)"
          outlined
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          :label="FieldLabel.SNILS"
          v-mask="Mask.SNILS"
          outlined
          disabled
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          :label="FieldLabel.INN"
          v-mask="Mask.INN"
          outlined
          disabled
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="v.trusteeStatus.$model"
          :errorMessages="getValidationErrorText(v.trusteeStatus)"
          label="Должность или статус представителя (при наличии)"
          outlined
        />
      </v-col>
    </v-row>

    <NotaryDocument :v="v.documents.authorityDocument" />

    <v-row>
      <v-col cols="3">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.phone.$model"
          :errorMessages="getValidationErrorText(v.phone)"
          v-mask="Mask.PHONE"
          label="Контактный телефон"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import { mdiAlertCircleOutline } from '@mdi/js';
import {
  EMAIL,
  EMOJI,
  getValidationErrorText,
  INN_ROD,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  PERSON_NAME,
} from '@/utils/validate';
import { DocumentType } from '@/types/services';
import { FieldLabel, FieldName, Mask } from '@/constants';
import NotaryDocument, {
  notaryDocumentModel,
  notaryDocumentValidation,
} from '@/components/services/elements/NotaryDocument';
import { AuthModule } from '@/store/modules/auth';
import cloneDeep from 'clone-deep';

export const getPersonTrusteeValidation = (isTrustee) => {
  if (!isTrustee) return {};

  return {
    lastName: {
      required,
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    firstName: {
      required,
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    patronymic: {
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    snils: {
      required,
      minLength: minLength(MinLength.SNILS),
    },
    inn: {
      minLength: minLength(12),
      required,
      INN: INN_ROD,
    },
    trusteeStatus: {
      maxLength: maxLength(1000),
      EMOJI,
    },
    email: {
      EMAIL,
      maxLength: maxLength(MAX_LENGTH_EMAIL),
    },
    phone: {
      minLength: minLength(16),
    },
    documents: {
      authorityDocument: notaryDocumentValidation,
    },
  };
};

export const personTrusteeModel = {
  lastName: '',
  firstName: '',
  patronymic: '',
  snils: '',
  inn: '',
  trusteeStatus: '',
  email: '',
  phone: '',
  documents: {
    authorityDocument: notaryDocumentModel,
  },
};

export const prefillEsiaPersonTrustee = async () => {
  const esiaPerson = await AuthModule.getPerson();
  const trustee = {};

  Object.keys(personTrusteeModel).forEach((fieldName) => {
    trustee[fieldName] = esiaPerson[fieldName] ?? personTrusteeModel[fieldName];
  });

  return cloneDeep(trustee);
};

export default {
  name: 'PersonTrustee',
  components: {
    NotaryDocument,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    mdiAlertCircleOutline,
    getValidationErrorText,
    DocumentType,
    Mask,
    FieldName,
    FieldLabel,
  }),
};
</script>
